import React from 'react';
import { Page } from '../Page';
import { PullQuote } from '../PullQuote';
export function PageTransitioning() {
  return <Page pageNumber={39} variant="light" data-id="element-1691" data-mp="3frh1y5s5dy27">
      <div className="flex flex-col h-full items-center" data-id="element-1692" data-mp="3focrwrs0483m">
        {/* Accent image strip */}
        <div className="h-[180px] w-[calc(100%+96px)] -mx-12 -mt-10 mb-8 overflow-hidden relative self-start" data-id="element-1693" data-mp="31t99aa259iwu">
          <img src="https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=1000&q=80" alt="Path at sunrise" className="w-full h-full object-cover object-center" data-id="element-1694" data-mp="3ufll1av44bli" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-1695" data-mp="3kqaftzbcjr2w" />
        </div>

        <div className="mb-10 text-center" data-id="element-1696" data-mp="3pntw14rludxh">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1697" data-mp="3pmipix6rys2o">
            Looking Ahead
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1698" data-mp="m0a7sclv2elv">
            Transitioning <span className="text-tealslate" data-id="element-1699" data-mp="37n6h5nl6ps2y">Off</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate mx-auto" data-id="element-1700" data-mp="37lbsby6slftl" />
        </div>

        <div className="max-w-md w-full flex flex-col flex-1" data-id="element-1701" data-mp="32qg0oz5gwuh0">
          <div className="space-y-6 text-sm text-[#3B3B3B] leading-[1.8] mb-10" data-id="element-1702" data-mp="3gg9n7ati32nk">
            <p data-id="element-1703" data-mp="3bpjhfwh5wxsc">
              Whether due to cost, side effects, or reaching your goal weight,
              you may eventually decide to stop taking GLP-1 medication. This is
              the most critical phase of your journey.
            </p>

            <div className="border-l-4 border-burgundy pl-5 py-4 bg-burgundy/5 my-8" data-id="element-1704" data-mp="3lel2i12ke5d6">
              <p className="text-sm font-serif text-[#1F1F1F] leading-[1.6]" data-id="element-1705" data-mp="386pc4c4dzfu">
                When you stop the medication, your appetite will return. Your
                digestion will speed up. If you have not built the habits
                outlined in this guide, you will regain the weight.
              </p>
            </div>

            <p data-id="element-1706" data-mp="211m0dd9dgx26">
              This is where calorie awareness becomes important. Refer back to
              the "When Calories Start to Matter" page to understand your
              maintenance needs.
            </p>
            <p data-id="element-1707" data-mp="dx2p5m49hjpr">
              The 5 essentials do not change. They become even more important
              without the medication's support. Protein and fiber will be your
              primary tools for managing hunger.
            </p>
            <p data-id="element-1708" data-mp="mwfxuckka49f">
              Work with your provider on a gradual taper rather than stopping
              abruptly. A slow reduction allows your body and your habits time
              to adjust.
            </p>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 mb-10" data-id="element-1709" data-mp="wpdnr3rvuvi2">
            <h3 className="font-serif text-lg text-[#1F1F1F] mb-3 text-center" data-id="element-1710" data-mp="11l2h2pdb7g5x">
              Expect Appetite to Increase
            </h3>
            <p className="text-xs text-[#7A7A70] leading-[1.6] text-center" data-id="element-1711" data-mp="16jng4lgtrtss">
              This is normal, not a failure. Your body's natural hunger signals
              will return. Weight maintenance requires the same habits you used
              to lose weight, just without the medication doing the heavy
              lifting on appetite control.
            </p>
          </div>

          <div className="mt-auto w-full" data-id="element-1712" data-mp="2m6io5tvp621r">
            <PullQuote text="The medication got you here. Your habits keep you here." variant="light" data-id="element-1713" data-mp="2h5v11jala5ct" />
          </div>
        </div>
      </div>
    </Page>;
}